import * as yup from 'yup';
import FormError from '../../../models/FormError';
import NewsletterSubscriptionFormEntry from '../models/NewsletterSubscriptionFormEntry';

export default class NewsletterSubscriptionFormValidationService {
    constructor(){}

    public translatedErrorMessages : any;
    

    private validationSchema: yup.ObjectSchema = yup.object().shape({
        email: yup.string().required("required_field").email("invalid_email"),
    });

    public async validateProperty(values: NewsletterSubscriptionFormEntry, propertyName: string): Promise<FormError[]> {
        let errors: FormError[] = [];
        try {
            await this.validationSchema.validateSyncAt(propertyName, values, { abortEarly: false });
        }
        catch (err) {
            if (err.errors.length > 0) {
                errors = [new FormError(propertyName, [this.translatedErrorMessages[err.errors[0]]])];
            }
        }

        return errors;
    }

    public async validate(values: NewsletterSubscriptionFormEntry): Promise<FormError[]> {
        let errors: FormError[] = [];

        try {
            await this.validationSchema.validateSync(values, { abortEarly: false });
        }
        catch (err) {
            errors = this.getFormErrorsFromValidationError(err);
        }
        return errors;
    }

    private getFormErrorsFromValidationError(validationError: any, formErrors?: FormError[]): FormError[] {
        formErrors = formErrors ?? [];
        if (validationError) {
            if (validationError.path) {
                if (formErrors.filter(err => { return err.field === validationError.path }).length === 0) {
                    const translatedMessage = this.translatedErrorMessages[validationError.message];
                    formErrors.push(new FormError(validationError.path, [translatedMessage]));
                }
            }

            if (validationError.inner && validationError.inner.length > 0) {
                for (let innerError of validationError.inner) {
                    this.getFormErrorsFromValidationError(innerError, formErrors);
                }
            }
        }
        return formErrors;
    }
}